<template>
  <div class="wc-autogrow-textarea">
    <textarea
      class="md-textarea wc-autogrow__container"
      :value="value"
      :style="{ height: height }"
      @input="$emit('input', $event.target.value)"
      @focus="onFocus"
      @blur="onBlur"
    ></textarea>
    <p class="wc-autogrow__content">{{ value }}</p>
  </div>
</template>
<script>
export default {
  name: "WcTextAreaAutogrow",
  inject: ["MdField"],
  props: {
    value: { default: "", type: String }
  },
  updated() {
    this.setHeight();
  },
  data() {
    return {
      height: "50px",
      focused: false
    };
  },
  methods: {
    setHeight() {
      const newHeight = this.$el.querySelector(".wc-autogrow__content").scrollHeight;
      const oldHeight = this.$el.querySelector(".wc-autogrow__container").clientHeight;
      if (newHeight !== oldHeight) {
        this.height = `${newHeight}px`;
      }
    },
    onFocus() {
      this.MdField.focused = true;
    },
    onBlur() {
      this.MdField.focused = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.wc-autogrow-textarea {
  width: 100%;
}

p {
  position: absolute;
  opacity: 0;
  max-width: 100%;
  height: 32px;
  overflow: scroll;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.wc-textarea--autogrow {
  max-height: initial;
}
</style>
